export const BRAND_PRESET_COLORS = [
	'#1c2e39',
	'#4f616c',
	'#247fff',
	'#0d5ef2',
	'#f4f5f6',
	'#ffffff',
];

const HEX = /^#?[0-9a-fA-F]{6}$/;

export const TRANSPARENT_COLOR = 'transparent';

export const isValidHex = (value: string): boolean => HEX.test(value.trim());

export const isTransparentColor = (value: string | number | undefined): boolean =>
	typeof value === 'string' && value.trim().toLowerCase() === TRANSPARENT_COLOR;

export const normalizeHex = (value: string | number | undefined): string =>
	typeof value === 'string' && isValidHex(value)
		? `#${value.replace('#', '').toLowerCase()}`
		: '#000000';

export const withCustomColors = (presets: string[], customColors: string[]): string[] => {
	const seen = new Set<string>();
	return [...customColors, ...presets]
		.filter((color) => {
			const key = color.toLowerCase();
			if (seen.has(key)) {
				return false;
			}
			seen.add(key);
			return true;
		})
		.slice(0, 6);
};
